import { createSelector } from 'reselect'

export const sliceSelector = (state) => state.reports;
export const errorMessage = createSelector(sliceSelector, slice => slice.errorMessage)
export const isSubmitting = createSelector(sliceSelector, slice => slice.isSubmitting);
